import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { AirCfarOfferV2 } from "@b2bportal/air-cfar-api";
import {
  type SelectedFintechOfferSelection,
  SelectedStatus,
} from "@b2bportal/core-types";
import {
  getChooseCfarV2TrackingProperties,
  getFetchedCfarOffers,
  getSelectedCfarOffer,
} from "../store/selectors";

export const useCfarV2StateForCheckout = () => {
  const selectedCfarOffer = useSelector(getSelectedCfarOffer);
  const fetchedCfarOffers = useSelector(getFetchedCfarOffers);
  const aggregatedShopTrackingProperties = useSelector(
    getChooseCfarV2TrackingProperties
  );

  const selectedOffer:
    | SelectedFintechOfferSelection<AirCfarOfferV2>
    | undefined = useMemo(
    () =>
      selectedCfarOffer.status === SelectedStatus.SELECTED
        ? {
            status: selectedCfarOffer.status,
            offer: selectedCfarOffer.offer as AirCfarOfferV2,
          }
        : undefined,
    [selectedCfarOffer]
  );

  return useMemo(() => {
    return {
      selectedOffer,
      cfarQuoteId:
        selectedOffer?.status === SelectedStatus.SELECTED
          ? selectedOffer.offer.quoteId
          : undefined,
      cfarOffers: fetchedCfarOffers as AirCfarOfferV2[],
      aggregatedShopTrackingProperties,
    };
  }, [selectedOffer, fetchedCfarOffers, aggregatedShopTrackingProperties]);
};
